import { cn } from "@app/lib/utils";
import { trans } from "@mongez/localization";

/**
 * Individual subsidiary item component
 * Displays subsidiary information in mobile/desktop layouts
 */
interface SubsidiaryItemProps {
  subsidiary: {
    name: string;
    capital: string;
    ownership: string;
    activism: string;
    country: string;
    state: string;
  };
  index: number;
  isParentOpen: boolean;
}

export function SubsidiaryItem({
  subsidiary,
  index,
  isParentOpen,
}: SubsidiaryItemProps) {
  return (
    <div
      className={cn(
        "w-full rounded-xl border bg-[#FBFBFB] sm:rounded-[17px]",
        "p-3 text-sm transition-all duration-500 ease-in-out sm:p-4 md:p-6",
      )}
      style={{
        transitionDelay: isParentOpen ? `${index * 50}ms` : "0ms",
      }}
    >
      {/* Mobile View */}
      <div className="md:hidden">
        <div className={cn("mb-2 font-medium text-gray-900")}>
          {trans(subsidiary.name)}
        </div>
        <div className={cn("grid grid-cols-2 gap-2 text-xs text-gray-700")}>
          <div>
            {trans("aboutUsPage.leadership.subsidiaries.table.capitalLabel")}:{" "}
            {trans(subsidiary.capital, {
              symbol: <span className="font-rubik">^</span>,
            })}
          </div>
          <div>
            {trans("aboutUsPage.leadership.subsidiaries.table.ownershipLabel")}:{" "}
            {subsidiary.ownership}
          </div>
          <div>
            {trans("aboutUsPage.leadership.subsidiaries.table.activityLabel")}:{" "}
            {trans(subsidiary.activism)}
          </div>
          <div>
            {trans("aboutUsPage.leadership.subsidiaries.table.countryLabel")}:{" "}
            {trans(subsidiary.country)}
          </div>
          <div className="col-span-2">
            {trans("aboutUsPage.leadership.subsidiaries.table.stateLabel")}:{" "}
            {trans(subsidiary.state)}
          </div>
        </div>
      </div>

      {/* Desktop View */}
      <div className={cn("hidden w-full items-center justify-between md:flex")}>
        <div
          className={cn(
            "grid w-full grid-cols-6 items-center gap-2 text-start sm:gap-4",
          )}
        >
          <div className={cn("font-medium text-gray-900")}>
            {trans(subsidiary.name)}
          </div>
          <div className={cn("text-gray-700")}>
            {trans(subsidiary.capital, {
              symbol: <span className="font-rubik">^</span>,
            })}
          </div>
          <div className={cn("text-gray-700")}>{subsidiary.ownership}</div>
          <div className={cn("text-gray-700")}>
            {trans(subsidiary.activism)}
          </div>
          <div className={cn("text-gray-700")}>{trans(subsidiary.country)}</div>
          <div className={cn("text-gray-700")}>{trans(subsidiary.state)}</div>
        </div>
        <span className={cn("ms-2 size-4 sm:ms-4 sm:size-5")} />
      </div>
    </div>
  );
}
